import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq, or } from 'ember-truth-helpers';

interface SettingsUsersTablesCellsCellDeleteSignature {
  Args: {
    row: {
      isDeletable?: boolean;
      isLocked?: boolean;
      onDelete?: () => void;
    };
  };
}

const CellDelete: TOC<SettingsUsersTablesCellsCellDeleteSignature> = <template>
  <div>
    <PrismButton
      @buttonType="secondary"
      @icon="bin"
      @isDisabled={{or @row.isLocked (eq @row.isDeletable false)}}
      @onClick={{@row.onDelete}}
      @size="small"
      data-test-id="cell-delete-button"
    />
    {{#if @row.isLocked}}
      <PrismTooltip
        @side="left"
        @text={{t "useraccess_rights_locked_content"}}
        @title={{t "useraccess_rights_locked"}}
      />
    {{else if (eq @row.isDeletable false)}}
      <PrismTooltip
        @side="left"
        @text={{t "useraccess_rights_delete_content"}}
        @title={{t "useraccess_rights_delete"}}
      />
    {{/if}}
  </div>
</template>;

export default CellDelete;
